import { Component, EventEmitter, inject, OnDestroy, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatCalendar } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { startWith, Subject, takeUntil } from 'rxjs';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'curbnturf-date-header',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, IonicModule],
  templateUrl: './date-header.component.html',
  styleUrl: './date-header.component.scss',
})
export class DateHeaderComponent<D> implements OnDestroy {
  private _calendar = inject<MatCalendar<D>>(MatCalendar);
  private _dateAdapter = inject<DateAdapter<D>>(DateAdapter);
  private _dateFormats = inject(MAT_DATE_FORMATS);

  private _destroyed = new Subject<void>();

  readonly periodLabel = signal('');

  @Output('monthChanged')
  monthChanged: EventEmitter<D> = new EventEmitter<D>();

  @Output('yearChanged')
  yearChanged: EventEmitter<D> = new EventEmitter<D>();

  constructor() {
    this._calendar.stateChanges.pipe(startWith(null), takeUntil(this._destroyed)).subscribe(() => {
      this.periodLabel.set(
        this._dateAdapter
          .format(this._calendar.activeDate, this._dateFormats.display.monthYearLabel)
          .toLocaleUpperCase(),
      );
    });
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  previousMonth() {
    this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1);
    this.monthChanged.emit(this._calendar.activeDate);
  }

  nextMonth() {
    this._calendar.activeDate = this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1);
    this.monthChanged.emit(this._calendar.activeDate);
  }

  previousYear() {
    this._calendar.activeDate = this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
    this.yearChanged.emit(this._calendar.activeDate);
  }

  nextYear() {
    this._calendar.activeDate = this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
    this.yearChanged.emit(this._calendar.activeDate);
  }
}
